export const CIQPRO_FEATURE_TOGGLE = 'ciqpro-navigation';
export const CIQPRO_PATH = 'capiqpro';
export const CIQPRO_CLIENT_PATH = 'ciqpro-client';
